import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  width: 100%;
  padding: 24px 8px;
`;

export const ComponentLabel = styled.div`
  background: ${(props) => props.theme.colors.info || '#52c41a'};
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 8px;
  width: fit-content;
  display: block;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 36px;

  .sidebar-edit-icon-collapsed {
    display: none;
  }

  ${(props) =>
    props.$isCollapsed &&
    `
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;

    .sidebar-edit-icon-collapsed {
      display: flex;
    }
  `}
`;

export const NewChatContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  justify-content: flex-start;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;

  ${(props) =>
    !props.$isSelected &&
    `
    &:hover {
      background-color: ${props.theme.colors.ghostWhite};
    }
  `}

  ${(props) =>
    props.$isSelected &&
    `
    background-color: ${props.theme.colors.titanWhite};
  `}

  ${(props) =>
    props.$isCollapsed &&
    `
    display: none;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  flex: 1;
  min-height: 0;
  ${(props) =>
    props.$isCollapsed &&
    `
    opacity: 0;
    pointer-events: none;
    height: 0;
    overflow: hidden;
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.ghostWhite};
  }
`;

export const DockWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.ghostWhite};
  }
`;